// Moved from `src/hooks/mutation/useMutateDeleteUserEntitlement.ts` (now a
// re-export delegate) with the EN4 mutation slice (ARCFE-1025). Verbatim —
// see `useMutateAssignTeamEntitlement.ts` for why this slice needs no port.
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type components } from '@heidi/schema/ml-scribe';

import { GET_TEAM_MEMBER_ACCESS_ENTITLEMENTS } from '../../contracts';
import { deleteUserEntitlementAsTeamAdmin } from '../api/entitlements';

export type DeleteUserEntitlementAsTeamAdminVariables = {
  userRefId: string;
  body: components['schemas']['DeleteUserAccessEntitlementRequest'];
  /** When set, invalidates team entitlements after a successful delete */
  teamId?: string;
};

/**
 * DELETE /api/v2/ml-scribe/access-entitlements/users/{user_ref_id}
 * Soft-delete a user's direct access entitlement. Caller must be a team admin; pass `teamId` to refresh team access entitlements on success.
 */
export function useMutateDeleteUserEntitlement() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      userRefId,
      body,
    }: DeleteUserEntitlementAsTeamAdminVariables) => {
      const { data } = await deleteUserEntitlementAsTeamAdmin(userRefId, body);
      return data;
    },
    onSuccess: (_data, variables) => {
      if (variables.teamId) {
        void queryClient.invalidateQueries({
          queryKey: [GET_TEAM_MEMBER_ACCESS_ENTITLEMENTS, variables.teamId],
        });
      }
    },
  });
}
